export function BRANCH_REQUEST(state) {
  state;
  state.branchs = {
    ...state.branchs,
    isLoading: true
  };
}
export function BRANCH_SUCCESS(state, payload) {
  payload.data.data.data.map(item => {
    const testItem = Object.keys(item).map(value => {
      if (item[value] === null) {
        item[value] = "-";
      }
      return item;
    });
    return testItem;
  });
  state;
  state.branchs = {
    ...state.branchs,
    data: payload.data.data.data,
    status: payload.data.status,
    count: payload.data.data.totalPage,
    isLoading: false
  };
}
export function BRANCH_ERROR(state, payload) {
  state;
  state.branchs = {
    isLoading: false,
    error: true,
    errorMessage: payload
  };
}
